/* v34 (owner, 2026-10-30): the showcase of features and the savings calculator's sliders.
   Showcase (sections/dex-features.liquid, layout "showcase"): a tile plays its picture while at least a third of it is
   on screen (is-in); the pictures borrowed from "How a request is handled" replay every 6 s (is-current on and off);
   a light follows the pointer over the tiles. Less motion = nothing moves, the finished pictures stay.
   Calculator (sections/dex-savings.liquid): a slider under "Computers" and "IT problems a month", kept in step with
   the number box both ways; the box's own input event is what recalculates (dex-v27.js), so the sums stay in one place.
   The answer glows a moment when it changes. */
(function () {
  var quiet = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------------------------------------------------------------- showcase
  document.querySelectorAll('[data-dex-show]').forEach(function (grid) {
    var tiles = [].slice.call(grid.querySelectorAll('.dex-show__tile'));
    if (!quiet && 'IntersectionObserver' in window) {
      var timers = new WeakMap();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var t = en.target;
          var stage = t.querySelector('.dex-show__stage');
          if (en.isIntersecting) {
            t.classList.add('is-in');
            if (stage && stage.querySelector('.dx-win, .dx-head') && !timers.get(t)) {
              var play = function () { stage.classList.remove('is-current'); void stage.offsetWidth; stage.classList.add('is-current'); };
              play();
              timers.set(t, setInterval(play, 6000));
            }
          } else {
            t.classList.remove('is-in');
            if (timers.get(t)) { clearInterval(timers.get(t)); timers.delete(t); }
            if (stage) stage.classList.remove('is-current');
          }
        });
      }, { threshold: 0.35 });
      tiles.forEach(function (t) { io.observe(t); });
    }
    // The light under the pointer (mice and pens only; a finger has nothing to follow).
    grid.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      var t = e.target.closest && e.target.closest('.dex-show__tile');
      if (!t) return;
      var r = t.getBoundingClientRect();
      t.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      t.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  });

  // ---------------------------------------------------------------- calculator sliders
  var RANGES = { pcs: [1, 300], problems: [1, 200] };
  document.querySelectorAll('[data-dex-calc]').forEach(function (root) {
    Object.keys(RANGES).forEach(function (name) {
      var box = root.querySelector('input[name="' + name + '"]');
      if (!box) return;
      var row = box.closest('.dex-calc__row');
      var label = row && row.querySelector('label');
      var s = document.createElement('input');
      s.type = 'range';
      s.className = 'dex-calc__slider';
      s.min = String(RANGES[name][0]);
      s.max = String(RANGES[name][1]);
      s.step = '1';
      if (label) s.setAttribute('aria-label', label.textContent.trim());
      var paint = function () {
        var v = Math.min(Math.max(parseFloat(s.value) || 0, RANGES[name][0]), RANGES[name][1]);
        s.style.setProperty('--v', ((v - RANGES[name][0]) / (RANGES[name][1] - RANGES[name][0]) * 100) + '%');
      };
      var fromBox = function () { var v = parseFloat(box.value); if (isFinite(v)) s.value = String(v); paint(); };
      fromBox();
      s.addEventListener('input', function (e) {
        e.stopPropagation();   // the box's own event below is the one that recalculates
        box.value = s.value;
        paint();
        box.dispatchEvent(new Event('input', { bubbles: true }));
      });
      box.addEventListener('input', fromBox);
      if (row) { row.classList.add('dex-calc__row--slider'); row.appendChild(s); }
    });
    if (quiet || !('MutationObserver' in window)) return;
    ['money', 'hours'].forEach(function (k) {
      var el = root.querySelector('[data-out="' + k + '"]');
      var p = el && el.parentElement;
      if (!p) return;
      new MutationObserver(function () {
        p.classList.remove('is-bump'); void p.offsetWidth; p.classList.add('is-bump');
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  });
})();
